import { cloudflareCDN } from "ui";
import {
  FFEScheduleItem,
  FFEScheduleItemSource,
  ProductInterface,
} from "ts-interfaces";
import { productOrMaterialThumbnail } from "../../../libs/util";

// An image that never sat in the rail: a user material's render. A web
// clip's materialData/mesh images are copies of its first scraped image.
const hasOwnImage = (product: ProductInterface) =>
  (product as { clipper?: boolean }).clipper !== true &&
  !!productOrMaterialThumbnail(product);

// refImages: [] = the user removed every image in the rail; show none unless
// the product has an image of its own to fall back to.
export const imagesCleared = (
  product: ProductInterface | undefined,
  source: FFEScheduleItemSource,
) =>
  source === "userProduct" &&
  product?.refImages?.length === 0 &&
  !hasOwnImage(product);

// A user product's row shows its first refImage — the one the image rail puts
// first. Web clips also freeze the scrape's first image into renderedImage,
// which productOrMaterialThumbnail prefers, so deleting it in the rail left
// it on the row. An untouched clip (refImages[0] still IS renderedImage)
// keeps the existing string, so cachedThumbnail isn't rewritten.
export const scheduleItemThumbnail = (
  product: ProductInterface,
  source: FFEScheduleItemSource,
): string => {
  if (imagesCleared(product, source)) return "";
  const cover = source === "userProduct" ? product.refImages?.[0] : undefined;
  return cover && cover !== product.materialData?.renderedImage
    ? cloudflareCDN(cover, "height=120,format=auto")
    : productOrMaterialThumbnail(product) || "";
};

// A row's thumbnail, falling back to its cachedThumbnail snapshot. Cleared
// images beat the snapshot: schedules other than the one edited keep theirs
// until they are next saved.
export const scheduleRowThumbnail = (
  item: FFEScheduleItem,
  product: ProductInterface | undefined,
): string => {
  if (!product) return item.cachedThumbnail || "";
  return (
    scheduleItemThumbnail(product, item.source) ||
    (imagesCleared(product, item.source) ? "" : item.cachedThumbnail || "")
  );
};
